export const styledUser = {
    alignItems: 'center',
    display: 'flex',
}

export const styledAvatar = {variants: {name: {true: {marginRight: '$avatarMarginHorizontal'}}}}

export const styledName = {
    color: '$userNameText',
    fontSize: '$userNameText',
    fontWeight: '$userNameText',
    maxWidth: '$userNameMaxWidth',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
}
